import { retrieveStoredAuthTokens } from 'shared/lib';

export const getAuthHeader = () => {
  const authTokens = retrieveStoredAuthTokens();
  return authTokens ? `Bearer ${authTokens.access}` : undefined;
};
